import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-stone-50">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-stone-500 hover:text-orange-800"
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
          Retour à l'accueil
        </Link>

        <h1 className="mt-8 text-4xl font-light tracking-tight text-stone-900 sm:text-5xl">
          Politique de confidentialité
          <span className="block italic text-orange-800">&amp; cookies</span>
        </h1>
        <p className="mt-3 text-sm text-stone-500">
          Dernière mise à jour&nbsp;: mai&nbsp;2026
        </p>

        <div className="prose prose-stone mt-12 max-w-none text-stone-700">
          <Section title="1 · Qui sommes-nous">
            <p>
              <strong>SAD — Solutions Agencement Décoration</strong>, entreprise
              individuelle exploitée par M.&nbsp;Marc VALDES, courtier en
              agencement situé à Saint-Paul, Île de la Réunion (974).
            </p>
            <p>
              Contact&nbsp;: <a href="mailto:contact@sad-reunion.re">contact@sad-reunion.re</a> ·
              {" "}<a href="tel:+262692714505">+262&nbsp;692&nbsp;71&nbsp;45&nbsp;05</a>
            </p>
          </Section>

          <Section title="2 · Données que nous collectons">
            <p>Via le formulaire de demande de devis&nbsp;:</p>
            <ul>
              <li>Nom et prénom</li>
              <li>Adresse email et numéro de téléphone</li>
              <li>Informations sur votre projet (type, budget, délai, description)</li>
            </ul>
            <p>
              Ces données ne sont collectées qu'avec votre action volontaire
              (envoi du formulaire) et utilisées exclusivement pour vous
              recontacter et établir un devis.
            </p>
          </Section>

          <Section title="3 · Cookies et mesure d'audience">
            <p>
              Notre site utilise deux outils de mesure pour comprendre comment
              les visiteurs interagissent avec nos pages&nbsp;:
            </p>
            <ul>
              <li>
                <strong>Google Analytics&nbsp;4</strong> — statistiques de
                visite anonymisées (pages vues, durée, source de trafic).
              </li>
              <li>
                <strong>Meta&nbsp;Pixel</strong> — mesure de l'efficacité de nos
                publicités Facebook/Instagram (uniquement si vous avez accepté
                les cookies).
              </li>
            </ul>
            <p>
              À votre arrivée sur le site, une bannière vous permet d'accepter
              ou de refuser le dépôt de cookies non essentiels. Votre choix est
              conservé sur votre appareil. Vous pouvez le modifier à tout moment
              en vidant les cookies de votre navigateur ou en nous écrivant.
            </p>
          </Section>

          <Section title="4 · Conservation des données">
            <p>
              Les demandes de devis sont conservées pendant 3&nbsp;ans à
              compter du dernier contact, dans le seul but de répondre à vos
              sollicitations et d'assurer le suivi commercial.
            </p>
            <p>
              Les données techniques (cookies analytiques) sont conservées
              26&nbsp;mois maximum.
            </p>
          </Section>

          <Section title="5 · Partage des données">
            <p>
              Vos données ne sont jamais vendues. Elles peuvent être partagées
              uniquement avec&nbsp;:
            </p>
            <ul>
              <li>
                Les fabricants partenaires que nous mettons en concurrence pour
                votre projet (uniquement avec votre accord explicite préalable).
              </li>
              <li>
                Nos prestataires techniques (hébergeur, service d'envoi
                d'emails Resend, Google&nbsp;Workspace) qui agissent sur nos
                instructions et sont liés par des engagements de
                confidentialité.
              </li>
            </ul>
          </Section>

          <Section title="6 · Vos droits (RGPD)">
            <p>
              Conformément au Règlement Général sur la Protection des Données,
              vous disposez à tout moment d'un droit d'accès, de rectification,
              d'effacement, de limitation et d'opposition concernant vos
              données.
            </p>
            <p>
              Pour exercer ces droits, écrivez-nous à&nbsp;
              <a href="mailto:contact@sad-reunion.re">contact@sad-reunion.re</a> en
              précisant l'objet de votre demande. Vous pouvez également
              introduire une réclamation auprès de la CNIL ({" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
                www.cnil.fr
              </a>).
            </p>
          </Section>

          <Section title="7 · Sécurité">
            <p>
              Notre site est servi en HTTPS, vos données transitent de manière
              chiffrée. Les emails de notification et accusés de réception sont
              également chiffrés (TLS) et signés (SPF / DKIM / DMARC).
            </p>
          </Section>
        </div>
      </div>
    </main>
  );
}

const Section = ({ title, children }) => (
  <section className="mt-12 first:mt-0">
    <h2 className="text-xs font-medium uppercase tracking-[0.22em] text-orange-800">
      {title}
    </h2>
    <div className="mt-4 space-y-4 text-base leading-relaxed text-stone-700">
      {children}
    </div>
  </section>
);
